import * as path from 'path';

import * as dotenv from 'dotenv';
import pino from 'pino';
import type { Logger } from 'pino';


const environment = process.env.NODE_ENV || 'development';

const isDevelopment = environment === 'development';
const isProduction = environment === 'production';
const isStaging = environment === 'staging';

const isBrowser = typeof window !== 'undefined';

function createBrowserLogger(): Logger {
  return pino({
    level: isProduction ? 'info' : 'debug',
    transport:
      isDevelopment || isStaging
        ? {
          target: 'pino-pretty',
          options: {
            colorize: true,
            translateTime: 'UTC:yyyy-mm-dd HH:MM:ss.l Z', // UTC format
            ignore: 'pid,hostname',
            singleLine: false,
            messageFormat: '{msg}',
          },
        }
        : undefined,
    serializers: {
      err: pino.stdSerializers.err,
      error: pino.stdSerializers.err,
    },
  });
}

function createServerLogger(): Logger {
  dotenv.config();

  const logFile = path.join(
    process.cwd(),
    process.env.LOG_PATH || 'logs',
    process.env.LOG_FILE || 'app.log'
  );

  const transportTargets = [];

  // Console/stdout transport for all environments — sandbox and production log
  // viewers (docker logs, kubectl logs, platform dashboards) read stdout, not the
  // file on disk, so this must not be gated to dev/staging only.
  transportTargets.push({
    level: isProduction ? 'info' : 'debug',
    target: 'pino-pretty',
    options: {
      colorize: isDevelopment || isStaging,
      translateTime: 'UTC:yyyy-mm-dd HH:MM:ss.l Z', // UTC format
      ignore: 'pid,hostname',
      singleLine: false,
      messageFormat: '{msg}',
    },
  });

  // File transport for all environments
  transportTargets.push({
    level: isProduction ? 'info' : 'debug',
    target: 'pino/file',
    options: { destination: logFile, mkdir: true },
  });

  return pino({
    level: isProduction ? 'info' : 'debug',
    transport: {
      targets: transportTargets,
    },
    serializers: {
      err: pino.stdSerializers.err,
      error: pino.stdSerializers.err,
    },
  });
}

const logger: Logger = isBrowser ? createBrowserLogger() : createServerLogger();

export { logger };
